import LastUpdatedDate from './LastUpdatedDate'

export default LastUpdatedDate
